import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const DocumentTypesDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: documentTypeOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'documentType',
    params: {
      windowId: 'documentTypes',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={documentTypeOptions} columnNames={COLUMN_NAMES} />;
};
